export default [
  {
    vid: "9578",
    name: "Test1",
    totalContact: "9825785690",
    status: "Active",
    createDate: "2021-11-02 16:29:58",
  },
  {
    vid: "9579",
    name: "Test2",
    totalContact: "9824755225",
    status: "Active",
    createDate: "2021-11-04 18:29:58",
  },
];
